import { Link } from "react-router-dom";
import { useHistory } from "react-router";
import Logo from "../Logo";
import Notification from "../Notifications/Notification";
import { useStoreContext } from "../../contexts/StoreProvider";
import styles from "./index.module.scss";
import ProfileDropdown from "../UserInterface/ProfileDropdown";
import { useAuthContext } from "../../contexts/AuthProvider";

const Header = ({ withNav = true }: { withNav?: boolean }) => {
  const {
    state: { user },
  } = useStoreContext();
  const history = useHistory();
  const { logout } = useAuthContext();
  const handleLogout = () => {
    logout();
  };

  const handleProfile = () => {
    history.push(
      `${user?.role.type === "administrator" ? "/admin" : ""}/profile`
    );
  };

  const handleEditProfile = () => {
    history.push(
      `${user?.role.type === "administrator" ? "/admin" : ""}/profile/edit`
    );
  };

  const handleChangePassword = () => {
    history.push("/change-password");
  };

  const options = [
    { value: "logout", label: "Logout", onClick: handleLogout },
    { value: "open_profile", label: "Open Profile", onClick: handleProfile },
    { value: "edit_profile", label: "Edit Profile", onClick: handleEditProfile },
    { value: "change_password", label: "Change Password", onClick: handleChangePassword},
  ];
  return (
    <header className={styles.header}>
      <div className={styles.content}>
        <div className={styles.leftCell}>
          <Link to="/">
            <Logo />
          </Link>
        </div>
        {withNav && (
          <>
            {user && (
              <div className={styles.user}>
                <Notification />
                <ProfileDropdown options={options} user={user} />
              </div>
            )}
          </>
        )}
      </div>
    </header>
  );
};

export default Header;
